import {BillingSummary} from "@/domain/BillingAccountSummary";
import {Money} from "@/component/style/Money";
import React from "react";
import {NumberTable} from "@/component/style/NumberTable";
import {Device} from "@/store/Device";

export function MidAccountTable(props: any) {
    return (
        <NumberTable>
            <thead>
            <tr>
                <th>계정</th>
                {!Device.isMobile && <th align="right">이월</th>}
                <th align="right">증감</th>
                <th align="right">잔액</th>
            </tr>
            </thead>
            <tbody>{props.children}</tbody>
        </NumberTable>
    );
}

export function MidAccountTableRow(props: {
    name: string;
    amounts: BillingSummary;
    className?: string;
}) {
    return (
        <tr className={props.className}>
            <td>{props.name}</td>
            {!Device.isMobile && <td align="right"><Money amount={props.amounts.carry}/></td>}
            <td align="right"><Money amount={props.amounts.inAmount - props.amounts.outAmount}/></td>
            <td align="right"><Money amount={props.amounts.balance}/></td>
        </tr>
    );
}
